export type PeriodoHorario = 'Manhã' | 'Tarde' | 'Noite';

export interface GrupoHorarios<T> {
  periodo: PeriodoHorario;
  slots: T[];
}

export interface HorariosAgrupados<T> {
  grupos: GrupoHorarios<T>[];
  /** Horários de hoje que já passaram (escondidos quando mostrarAnteriores é false). */
  anteriores: number;
  livres: number;
}

const PERIODOS: PeriodoHorario[] = ['Manhã', 'Tarde', 'Noite'];

export function minutosDoHorario(hr: string | null | undefined): number | null {
  const m = /(\d{1,2}):(\d{2})/.exec(hr ?? '');
  return m ? Number(m[1]) * 60 + Number(m[2]) : null;
}

export function periodoDoHorario(minutos: number): PeriodoHorario {
  if (minutos < 12 * 60) return 'Manhã';
  return minutos < 18 * 60 ? 'Tarde' : 'Noite';
}

/** Slots do dia (hrAgenda "HH:MM") em ordem, por período; sem `agora` nada conta como passado. */
export function agruparHorarios<T extends { hrAgenda: string }>(
  slots: T[],
  opcoes: { agora?: Date | null; mostrarAnteriores?: boolean } = {},
): HorariosAgrupados<T> {
  const agora = opcoes.agora ? opcoes.agora.getHours() * 60 + opcoes.agora.getMinutes() : null;
  const comMinuto = slots
    .map(slot => ({ slot, min: minutosDoHorario(slot.hrAgenda) }))
    .sort((a, b) => (a.min ?? Infinity) - (b.min ?? Infinity));

  const porPeriodo = new Map<PeriodoHorario, T[]>();
  let anteriores = 0;
  for (const { slot, min } of comMinuto) {
    const passou = agora != null && min != null && min < agora;
    if (passou) anteriores++;
    if (passou && !opcoes.mostrarAnteriores) continue;
    const periodo = min == null ? 'Noite' : periodoDoHorario(min);
    porPeriodo.set(periodo, [...(porPeriodo.get(periodo) ?? []), slot]);
  }

  return {
    grupos: PERIODOS.filter(p => porPeriodo.has(p)).map(periodo => ({ periodo, slots: porPeriodo.get(periodo)! })),
    anteriores,
    livres: slots.length - anteriores,
  };
}
